import { AbstractControl, ValidationErrors } from '@angular/forms';

export function locationRequiredValidator(control: AbstractControl): ValidationErrors | null {
  const value = control.value;
  if (!value || !value.city_id) {
    return { required: true };
  }
  return null;
}
